export const CACHE_TIME = 1000 * 60 * 10
export const LIMIT = 50
export const IMAGE_SIZE = 100
